import React from 'react';
import {getPublicImagePath, MarkupRender, Modal} from '@nutastic/nutastic-react-app';

// eslint-disable-next-line react/prop-types
const StoryModal = ({ isOpen, onClose, content, title }) => {
    return <Modal show={isOpen} onClose={onClose} title={title}>
        <MarkupRender content={content} tagName="div" className="story-content" />
        <div className="story-content">
            Unmask Purpose is about a lifestyle of serving, building, and honoring the person God has called us to be.
            It's about stepping out in faith each day and embracing the purpose in both the joy and challenges of life.
            <br /><br />
            Unmasking is freeing yourself from everything that's not of you, building yourself up brick by brick, & celebrating what it takes to be You.
            You are PURPOSE, living on PURPOSE.
            <br /><br />
            <b>GET TO KNOW US</b>
            <br />
            Get to know the women of Unmask Purpose <b>(LaRonda James & Joyana Foster)</b> more by clicking the images below to visit their personal social pages.
            Follow us on our official Unmask Purpose social pages to keep up with what we do and how we serve!
            <br /><br />
            <div className="team-images">
                <a href="https://larondajames.com/home" target="_blank" rel="noreferrer">
                    <img src={getPublicImagePath('avi--lj.png')} alt="LaRonda James | Unmask Purpose" />
                </a>
                <a href="https://www.instagram.com/joyeux_bae/" target="_blank" rel="noreferrer">
                    <img src={getPublicImagePath('avi--yanni.png')} alt="Joyana Foster | Unmask Purpose" />
                </a>
            </div>
        </div>
    </Modal>;
};

export default StoryModal;
